/* Keep Reformation's native close handlers and footer toggle behavior. */
(() => {
  if (window.planetfootPanelKeyboard) return;
  window.planetfootPanelKeyboard = true;
  document.addEventListener('keydown', (event) => {
    const close = event.target.closest?.('side-panel-close[role="button"]');
    if (!close || event.target !== close || event.repeat || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    close.click();
  });

  const desktop = window.matchMedia('(min-width: 768px)');
  const observedFooters = new WeakSet();
  const updateFooter = (footer) => {
    footer.querySelectorAll('.thb-widget-title.collapsible').forEach((button, index) => {
      const menu = button.nextElementSibling;
      if (!menu?.classList.contains('thb-widget-menu')) return;
      if (!menu.id) {
        const sectionId = footer.closest('.shopify-section')?.id || footer.id || 'planetfoot-footer';
        menu.id = `${sectionId}-menu-${index}`;
      }
      button.setAttribute('aria-controls', menu.id);
      button.setAttribute('aria-expanded', String(desktop.matches || button.classList.contains('active')));
    });
  };
  const initializeFooters = () => {
    document.querySelectorAll('footer.footer').forEach((footer) => {
      updateFooter(footer);
      if (observedFooters.has(footer)) return;
      observedFooters.add(footer);
      new MutationObserver((records) => {
        if (records.some((record) => record.target.matches('.thb-widget-title.collapsible'))) updateFooter(footer);
      }).observe(footer, { attributes: true, attributeFilter: ['class'], subtree: true });
    });
  };
  desktop.addEventListener('change', initializeFooters);
  document.addEventListener('shopify:section:load', initializeFooters);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeFooters, { once: true });
  else initializeFooters();
})();
